var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "17px",
    viewBox: "0 0 25 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-enable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finals---specs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-field-examples",
    transform: "translate(-280.000000, -290.000000)",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(15.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes",
    transform: "translate(264.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-enable",
    transform: "translate(1.000000, 3.768021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22257246,7.92635789 C8.22257246,5.62372632 10.0646014,3.75030526 12.3290942,3.75030526 C14.593587,3.75030526 16.4359783,5.62372632 16.4359783,7.92635789 C16.4359783,10.2289895 14.593587,12.1020421 12.3290942,12.1020421 C10.0646014,12.1020421 8.22257246,10.2289895 8.22257246,7.92635789 Z M7.13561594,7.92635789 C7.13561594,10.8379895 9.46568841,13.2073053 12.3290942,13.2073053 C15.1928623,13.2073053 17.5229348,10.8379895 17.5229348,7.92635789 C17.5229348,5.01435789 15.1928623,2.64504211 12.3290942,2.64504211 C9.46568841,2.64504211 7.13561594,5.01435789 7.13561594,7.92635789 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22695652,7.95292105 C1.98818841,6.72497368 5.7515942,1.24876316 12.282029,1.24876316 C18.7925362,1.24876316 22.64,6.71502632 23.4276812,7.95328947 C22.7526812,9.23023684 19.4838406,14.6040263 12.282029,14.6040263 C5.0726087,14.6040263 1.87731884,9.21734211 1.22695652,7.95292105 Z M24.522971,7.65302632 C24.3515942,7.3465 20.2294928,0.1435 12.282029,0.1435 C4.33166667,0.1435 0.300507246,7.35092105 0.132753623,7.65781579 L0.000144927536,7.90097368 L0.112463768,8.15407895 C0.14615942,8.22923684 3.5707971,15.7092895 12.282029,15.7092895 C20.988913,15.7092895 24.5088406,8.23513158 24.5436232,8.15960526 L24.6617391,7.90097368 L24.522971,7.65302632 Z",
    id: "Fill-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeEnable);
export default __webpack_public_path__ + "static/media/eye-enable.0538c469d63f0d01e0589278edb5d70e.svg";
export { ForwardRef as ReactComponent };